"use strict";

define('rs/models/contact',['rs/models/abstract', 'rs/helper'], function (AbstractModel, helper) {
  var ContactModel = AbstractModel.extend({
    properties: ['id', 'activityDate', 'firstName', 'lastName', 'middleName', 'prefix', 'suffix', 'title', 'updateUserAuthId', 'version'],
    requestDetails: function requestDetails() {
      return Promise.resolve(this);
    }
  }, {
    parsers: {}
  });
  return ContactModel;
});

